import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AttendanceTracker = ({ attendanceRecords, onUpdate }) => {
  const activeRecords = attendanceRecords?.filter(r => r?.check_in_time && !r?.check_out_time);

  const getStatus = (record) => {
    if (record?.lunch_start_time && !record?.lunch_end_time) {
      return { label: 'On Lunch Break', color: 'orange', icon: 'Coffee' };
    }
    if (record?.check_in_time && !record?.check_out_time) {
      return { label: 'Working', color: 'green', icon: 'CheckCircle' };
    }
    return { label: 'Checked Out', color: 'gray', icon: 'LogOut' };
  };

  const calculateDuration = (startTime) => {
    const start = new Date(startTime);
    const now = new Date();
    const diffMs = now - start;
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    return `${hours}h ${minutes}m`;
  };

  return (
    <div className="bg-card rounded-lg shadow-md p-6 border border-border">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <Icon name="Users" size={24} className="text-primary" />
          <h2 className="text-xl font-bold text-foreground">Active Staff</h2>
        </div>
        <Button
          onClick={onUpdate}
          variant="outline"
          size="sm"
          className="flex items-center gap-2"
        >
          <Icon name="RefreshCw" size={16} />
          Refresh
        </Button>
      </div>
      {activeRecords?.length > 0 ? (
        <div className="space-y-3">
          {activeRecords?.map((record) => {
            const status = getStatus(record);
            return (
              <div
                key={record?.id}
                className="p-4 bg-background rounded-lg border border-border"
              >
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name={status?.icon} size={20} className={`text-${status?.color}-500`} />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="font-bold text-foreground">
                        {record?.user_profiles?.full_name}
                      </h3>
                      <span className={`text-xs px-2 py-1 rounded-full bg-${status?.color}-500/10 text-${status?.color}-500`}>
                        {status?.label}
                      </span>
                    </div>

                    <div className="grid grid-cols-2 gap-2 text-sm mb-2">
                      <div>
                        <p className="text-muted-foreground text-xs">Check-In</p>
                        <p className="font-medium text-foreground">
                          {new Date(record?.check_in_time)?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                        </p>
                      </div>
                      <div>
                        <p className="text-muted-foreground text-xs">Duration</p>
                        <p className="font-medium text-foreground">
                          {calculateDuration(record?.check_in_time)}
                        </p>
                      </div>
                    </div>

                    {record?.lunch_start_time && (
                      <div className="mt-2 p-2 bg-orange-500/10 border border-orange-500/20 rounded">
                        <div className="flex items-center gap-2 text-xs">
                          <Icon name="Coffee" size={14} className="text-orange-500" />
                          <span className="text-foreground">
                            Lunch started at {new Date(record?.lunch_start_time)?.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                          </span>
                        </div>
                      </div>
                    )}

                    {record?.lunch_end_time && (
                      <div className="mt-2 text-xs text-muted-foreground">
                        Lunch duration: {Math.round((new Date(record?.lunch_end_time) - new Date(record?.lunch_start_time)) / (1000 * 60))} minutes
                      </div>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center text-muted-foreground py-12">
          <Icon name="Users" size={48} className="mx-auto mb-4 opacity-50" />
          <p className="text-lg font-medium">No Active Staff</p>
          <p className="text-sm mt-2">No staff members are currently checked in</p>
        </div>
      )}
    </div>
  );
};

export default AttendanceTracker;